<template>
  <div>
    <el-button
      style="cursor: pointer"
      type="info"
      circle
      :loading="listLoading"
      icon="el-icon-message"
      @click="getList"
    ></el-button>
    <el-dialog :visible.sync="dialogTableVisible" :title="`商家列表（${list.length}）`" fullscreen>
      <div style="position: relative; min-height: 300px; height: 100%">
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          max-height="700"
        >
          <el-table-column align="center" label="ID" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="商家 LOGO" width="100">
            <template slot-scope="scope">
              <el-image
                style="height: 60px; width: 60px; border-radius: 50%; border: 1px solid #ddd"
                v-if="scope.row.fileInfo"
                :src="
                  scope.row.fileInfo.url ? scope.row.fileInfo.url : 'https://fakeimg.pl/300/300'
                "
                fit="cover"
                :preview-src-list="[scope.row.fileInfo.url]"
                :lazy="true"
              >
              </el-image>
              <el-image
                style="height: 60px; width: 60px; border-radius: 50%; border: 1px solid #ddd"
                v-else
                :src="'https://fakeimg.pl/300x300/'"
                fit="cover"
                :preview-src-list="['https://fakeimg.pl/300/300']"
                :lazy="true"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column align="center" label="名稱" prop="name" />
          <el-table-column align="center" label="統編" width="120" prop="vatNumber" />
          <el-table-column align="center" label="負責人" width="160" prop="boss" />
          <el-table-column align="center" label="電話" width="160" prop="tel" />
          <el-table-column align="center" label="地址" width="200" prop="address" />
          <el-table-column align="center" label="E-Mail" width="160" prop="mail" />
          <el-table-column align="center" label="簽約期間" width="200">
            <template slot-scope="scope">
              <span> {{ scope.row.startDate }} 至 {{ scope.row.endDate }} </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="簽約狀態" width="100" fixed="right">
            <template slot-scope="scope">
              <el-tag :type="handleStatus(scope.row.startDate, scope.row.endDate).type">{{
                handleStatus(scope.row.startDate, scope.row.endDate).text
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        layout="prev, pager, next"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerCompaniesFullData } from '@/api/advertisement'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import dayjs from 'dayjs'

export default {
  name: '',
  data() {
    return {
      listLoading: false,
      dialogTableVisible: false,
      list: [],
      total: 0,
      listQuery: {
        qry: '',
        status: null,
        page: 1,
        limit: 100,
        sort: '-id',
      },
    }
  },
  components: { Pagination },
  methods: {
    // 取得列表
    async getList() {
      this.listLoading = true
      await getCustomerCompaniesFullData(this.listQuery)
        .then(res => {
          this.total = res.data.total
          this.list = res.data.data
          this.dialogTableVisible = true
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleStatus(startDate, endDate) {
      const today = dayjs()
      if (today.isAfter(startDate) && today.isBefore(endDate)) {
        return {
          text: '進行中',
          type: 'success',
        }
      }
      if (today.isBefore(startDate)) {
        return {
          text: '未生效',
          type: 'warning',
        }
      }
      if (today.isAfter(endDate)) {
        return {
          text: '已失效',
          type: 'info',
        }
      }
      // 添加默認返回值
      return {
        text: '已結束',
        type: 'info',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.coupon-link {
  color: #1890ff;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 75%;
  }
}
</style>
